import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export type Role = 'admin' | 'pharmacist' | 'user';


export function checkPermission(requiredRole: Role | Role[], userRole: Role): boolean {
  const roleHierarchy: Record<Role, number> = {
    admin: 3,
    pharmacist: 2,
    user: 1
  };

  if (Array.isArray(requiredRole)) {
    return requiredRole.some(role => roleHierarchy[userRole] >= roleHierarchy[role]);
  }

  return roleHierarchy[userRole] >= roleHierarchy[requiredRole];
}